import { render, staticRenderFns } from "./keyPartner.vue?vue&type=template&id=0d137d9c&scoped=true&"
import script from "./keyPartner.vue?vue&type=script&lang=js&"
export * from "./keyPartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d137d9c",
  null
  
)

export default component.exports